import { date, time } from '@beelday/common'
import { useSelector } from 'app-redux'
import {
	selectCurrentScriptStep,
	selectScript,
} from 'features/script/script-redux'
import { FC, useMemo } from 'react'
import { ConfiguredPresenterSettings } from './configured-presenter-settings'
import { Formats, panelView } from './model/console-view'
import { isRunning } from './model/presentation-machine'
import { usePresenterConsole } from './presenter-console'
import { PresenterPanel } from './presentation/presenter-panel'
import { useFillsScreen } from './use-fills-screen'
import { useNow } from './use-now'

/** The presenter panel beside the stage, while a presentation runs. */
export const ConfiguredPresenterPanel: FC = () => {
	const presenter = usePresenterConsole()
	const script = useSelector(selectScript)
	const current = useSelector(selectCurrentScriptStep)
	const dateFormat = date.useDateFormat()
	const now = useNow(1000)
	const fillsScreen = useFillsScreen()
	const format = useMemo<Formats>(
		() => ({
			time: dateFormat.formatTime,
			day: day => dateFormat.formatDate(day, 'SHORT'),
			duration: time.toTimeString,
		}),
		[dateFormat]
	)

	if (!presenter || !isRunning(presenter.state)) {
		return null
	}
	return (
		<PresenterPanel
			view={panelView({ state: presenter.state, script, current, now, format })}
			settings={<ConfiguredPresenterSettings />}
			blank={presenter.state.blank}
			showMaximise={!fillsScreen}
			onToggleBlank={presenter.toggleBlank}
			onEnd={presenter.end}
		/>
	)
}

export default ConfiguredPresenterPanel
